var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3441 22.1247V22.6247H15.8441H21.1874C21.9805 22.6247 22.6246 21.9811 22.6246 21.1875V2.81254C22.6246 2.02011 21.9808 1.37532 21.1874 1.37532H2.81259C2.01955 1.37532 1.37535 2.0189 1.37535 2.81254V21.1875C1.37535 21.9799 2.01923 22.6247 2.81259 22.6247H12.9398H13.4398V22.1247V14.4843V13.9843H12.9398H10.6264V12.0779H12.9398H13.4398V11.5779V9.57075C13.4398 7.45904 15.1412 5.75037 17.2508 5.75037H18.6729V7.6568H17.2508C16.1792 7.6568 15.3449 8.491 15.3449 9.56262V11.5779V12.0779H15.8449H18.6304L18.3162 13.9843H15.8441H15.3441V14.4843V22.1247ZM2.81259 0.5H21.1874C22.4613 0.5 23.4993 1.53822 23.5 2.81281V21.1875C23.5 22.4625 22.4624 23.5 21.1874 23.5H2.81259C1.5376 23.5 0.5 22.4625 0.5 21.1875V2.81254C0.5 1.53752 1.5376 0.5 2.81259 0.5Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a471855d84dc228013e59d67d407de40.svg";
export { ForwardRef as ReactComponent };